import { DefaultTheme } from "styled-components";

export const vitatTheme: DefaultTheme = {
  title: "vitat",

  colors: {
    primary: "#9dc11d",
    secondary: "#2F334B",
    chatMessage: "#2F334B",
    header: "#2F334B",
    background: "#a9ca33",
  },

  images: {
    logo: "https://senc.icmc.usp.br/img/patrocinio/2021/vitat.png",
    background: "",
  },
};
